module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-pool-photo.8db4010c.jpg";